import { useContext, useEffect, useState, Suspense } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { ErrorBoundary, useRollbarPerson } from '@rollbar/react'
import NavMenu from 'components/NavMenu/NavMenu'
import Header from 'components/Header/Header'
import { isMobile } from 'helpers/styles'
import style from './PageWrapper.module.scss'
import Back from 'components/common/Back/Back'
import NavMenuFooter from 'components/NavMenuFooter/NavMenuFooter'
import NotFoundPage from 'components/NotFoundPage/NotFoundPage'
import ClientContext from 'contexts/ClientContext'
import colors from 'styles/colors.scss'
import CoLabelPopup from 'components/CoLabelPopup/CoLabelPopup'
import api from 'helpers/api'

const PageWrapper = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [ contract, setContract ] = useState({})
  const [ colabelOptions, setColabelOptions ] = useState({})
  const [isMenuRendered, setIsMenuRendered] = useState(!isMobile())
  const client = useContext(ClientContext)
  const accessToken = localStorage.getItem('accessToken')
  const isAuthRoute = [
    'sign-in',
    'sign-up',
    'sign-up-confirm',
    'reset-password',
    'reset-password/requested'
  ].includes(pathname.slice(1))

  useRollbarPerson(client)

  useEffect(() => {
    if (pathname === '/') navigate('contracts')

    const getDatas = async () => {
      try{
        const res = await api.get({ url: '/adhesions/colabel' })
        if (res?.adhesions) setColabelOptions(res)
      } catch (err) {}
    }
    if (accessToken && !colabelOptions.adhesions) getDatas()
  }, [pathname, navigate, accessToken])

  window.onresize = () => {
    setIsMenuRendered(!isMobile())
  }

  const onNavItemClick = path => {
    if (isMenuRendered) setIsMenuRendered(false)
    navigate(path)
  }

  const onToggleMenu = () => {
    setIsMenuRendered(!isMenuRendered)
  }

  const AuthRoute = () => (
    <div className={style.auth}>
      <Header darkBg styles={{ position: 'absolute', top: 0 }} />
      <Outlet />
    </div>
  )

  return (
    <Suspense fallback={''}>
      {!isAuthRoute
        ? !accessToken
          ? <Navigate to={'/sign-in'} replace />
          : <ErrorBoundary fallbackUI={NotFoundPage}>
            {colabelOptions.adhesions &&
              <ClientContext.Provider value={{
                ...contract,
                setContract,
                ...colors,
                ...colabelOptions
              }}>
                <div className={style['page-wrapper']}>
                  {colabelOptions.popup && <CoLabelPopup />}
                  {isMenuRendered && <NavMenu onNavItemClick={onNavItemClick} />}
                  <div className={style.content}>
                    <Header />
                    <Back className={style.back} />
                    <div className={style.outlet}>
                      <Outlet />
                    </div>
                    {isMobile() && <NavMenuFooter className onNavItemClick={onNavItemClick} onToggleMenu={onToggleMenu} />}
                  </div>
                </div>
              </ClientContext.Provider>
            }
          </ErrorBoundary>
        : accessToken
          ? <Navigate to={'/contracts'} replace />
          : <AuthRoute />
      }
    </Suspense>
  )
}

export default PageWrapper
